import { FormWithRedux } from '../../FormWithRedux';

export class EDChestPainProbabilityOfMACEGraphForm extends FormWithRedux {

    constructor() {
        super('probabilityOfMACEGraphForm');
    }

    getGraphValue(){
        return this.getValue('probabilityOfMACE');
    }

    shouldDisplayFormDetailForIdentifier() {
        return true;
    }

    isEnabled() {
        return true;
    }

    isMandatory() {
        return false;
    }

    getValueType() {
        return null;
    }

    submissionValidation() {
        return [];
    }

    editingValidation() {
        return [];
    }

    detailString() {
        return this.detail;
    }

}


// WEBPACK FOOTER //
// ./src/forms/edChestPain01/Forms/EDChestPain-ProbabilityOfMACEGraphForm.js